import React from 'react'
import { Card, Col, Row } from 'react-bootstrap';

function TodayRestDays({ restDays = [] }) {
  const cardStyle = {
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
    marginBottom: "20px",
  };

  const rowStyle = {
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
  };

  const headerStyle = {
    fontWeight: "600",
    borderBottom: "2px solid #dee2e6",
    paddingBottom: "8px",
  };

  return (
    <Card style={cardStyle}>
      <Card.Header className="bg-warning text-white">
        <strong>Today's Rest days</strong>
      </Card.Header>
      <Card.Body>
        {restDays.length === 0 ? (
          <div className="text-muted">No employees on rest days today.</div>
        ) : (
          <div>
            <Row style={headerStyle} className="text-muted small">
              <Col sm={3}>EMP Id</Col>
              <Col sm={5}>Employee Name</Col>
              <Col sm={4}>Project Name</Col>
            </Row>
            {restDays.map((restDay, index) => (
              <Row key={index} style={rowStyle}>
                <Col sm={3}>{restDay.empid}</Col>
                <Col sm={5}>{restDay.fullName}</Col>
                <Col sm={4}>{restDay.projectName}</Col>
              </Row>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}



export default TodayRestDays